import { useContext, useLayoutEffect, useRef, useState } from "react";
import { ForMnSteps, BurgerButtonBig, ButtonRound, DropdownInfo, HeaderBig, LearnMore, SignupBox } from "../common/Common";
import './ForMn.css';
import { LocaleContext } from "../common/App";
import { Footer } from "./WebsiteCommon";
import { useNavigateSmart } from "../common/hooks";

export function ForMn(props) {
    const locale = useContext(LocaleContext);
    const navigate = useNavigateSmart();

    return (
        <div>
            <img className="img_width" src="/customer/03_header_for_mannynanny.jpg"></img>
            <div className="text_box">
                <div className="text_small">{locale.msgs.FOR_M_N}</div>

                <div className="text_big_big margin_top_middle">{locale.msgs.BROKERAGE_BEST_JOB}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.BROKERAGE_BEST_JOB_DESCR}}></div>

                <div className="text_big_big margin_top_middle">{locale.msgs.HOW_BROKERAGE_WORKS}</div>
            </div>

            <img className="img_width margin_top_low_low" src="/customer/02_body_dashboard_mannynanny.jpg"></img>

            <div className="text_box">
                <ForMnSteps/>
            </div>

            <div className="text_box">
                <div className="text_big_big margin_top_middle">{locale.msgs.AMOUNT_OF_WAGE}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.AMOUNT_OF_WAGE_DESCR}}></div>

                <div className="text_big_big margin_top_middle">{locale.msgs.WAY_OF_EMPLOYMENT}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.WAY_OF_EMPLOYMENT_DESCR}}></div>

                <div className="margin_top_high">
                    <SignupBox header={locale.msgs.FIND_JOB_2} descr={locale.msgs.FIND_JOB_DESCR_MN}
                            onClick={() => navigate("/register_mn") } />
                </div>
            </div>
            
            <img className="img_width margin_top_high margin_bottom_high" src="/customer/body-for-mannynanny.jpg"></img>

            {/*
            <div className="text_box_gray margin_bottom_high">
                <div className="text_big_big">{locale.msgs.OUR_ACADEMY}</div>
                <div className="text">{locale.msgs.OUR_ACADEMY_DESCR}</div>
                <LearnMore href="/login"/>
            </div>
            */}

            <Footer />
        </div>
    );
}
